import React, { useState } from 'react';
import { useT } from '../i18n/I18nContext';

// Opções do Excel — idioma e moeda. Usado tanto na cotação quanto no pedido:
//  • idioma: inglês para o fornecedor, português para uso interno/contabilidade
//  • moeda: só a moeda de negociação (planilha limpa p/ o fornecedor) ou
//    também as colunas em BRL (custo estimado para dentro de casa)
export default function ExportOptionsModal({ onExport, onClose, exporting, multiplier, currency, kind = 'quotation' }) {
  const t = useT();
  const [lang, setLang] = useState('en');
  const isRMB = currency === 'RMB';
  const nativeLabel = isRMB ? '¥ RMB' : '$ USD';
  const pct = Math.round(((multiplier || 1.6) - 1) * 100);

  const optBtn = (active) => ({
    flex: 1, padding: '10px 12px', fontSize: 13, cursor: 'pointer', borderRadius: 'var(--radius)',
    border: active ? '2px solid var(--pantone)' : '1px solid var(--gray-200)',
    background: active ? 'var(--pantone-pale)' : 'white',
    color: active ? 'var(--pantone)' : 'var(--gray-600)',
    fontWeight: active ? 700 : 400,
  });

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 470 }}>
        <div className="modal-header">
          <div className="modal-title">
            📥 {kind === 'order' ? t('export.title_order') : t('export.title_quotation')}
          </div>
          <button className="btn btn-ghost btn-sm btn-icon" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {/* Idioma */}
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--gray-500)', marginBottom: 8 }}>
            {t('export.language')}
          </div>
          <div style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
            <button type="button" style={optBtn(lang === 'en')} onClick={() => setLang('en')}>
              🇺🇸 {t('export.lang_en')}
            </button>
            <button type="button" style={optBtn(lang === 'pt')} onClick={() => setLang('pt')}>
              🇧🇷 {t('export.lang_pt')}
            </button>
          </div>
          <div style={{ fontSize: 11, color: 'var(--gray-400)', marginBottom: 20 }}>
            {lang === 'en' ? t('export.lang_en_hint') : t('export.lang_pt_hint')}
          </div>

          {/* Moeda */}
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--gray-500)', marginBottom: 8 }}>
            {t('export.currency')}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <button className="btn btn-primary w-full" disabled={exporting}
              onClick={() => onExport('usd', lang)}
              style={{ justifyContent: 'flex-start', padding: '14px 18px' }}>
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: 14, fontWeight: 700 }}>{isRMB ? '¥' : '💵'} {t('export.native_only')}</div>
                <div style={{ fontSize: 11, opacity: .78, fontWeight: 400, marginTop: 2 }}>
                  {nativeLabel} · {t('export.native_desc')}
                </div>
              </div>
            </button>
            <button className="btn btn-accent w-full" disabled={exporting}
              onClick={() => onExport('both', lang)}
              style={{ justifyContent: 'flex-start', padding: '14px 18px' }}>
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: 14, fontWeight: 700 }}>
                  {isRMB ? '¥' : '💵'} + 🇧🇷 {isRMB ? 'RMB' : 'USD'} + BRL
                </div>
                <div style={{ fontSize: 11, opacity: .85, fontWeight: 400, marginTop: 2 }}>
                  ×{Number(multiplier || 1.6).toFixed(2)} · +{pct}% · {t('export.both_desc')}
                </div>
              </div>
            </button>
          </div>
          {exporting && (
            <div style={{ textAlign: 'center', marginTop: 16, color: 'var(--gray-500)', fontSize: 13 }}>
              {t('export.generating')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
